module.exports = __webpack_public_path__ + "static/NicolaRizz-225686b2121bb039cfdb1160c0b389af.png";